import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { resetDibsOpener } from '../../reducers/dibsOpener';
import { openDIBS } from '../../helpers/dibs';
import CompletedCaseModificationWarning from '../CompletedCaseModificationWarning';
import UnstableUsageDetector from './UnstableUsageDetector';

const DibsOpener = ({ organizationId, patient, app, fileId, reset, open }) => {
  const [checks, setChecks] = useState(0);
  const checkLimit = organizationId ? 2 : 1;

  useEffect(() => {
    if (checks === checkLimit) {
      let uri;
      if (fileId) {
        uri = `open_file/${fileId}`;
      } else {
        uri = `open_patient/${patient.id}`;
      }

      open(app, uri);
      reset();
      setChecks(0);
    }
  }, [checks, patient, fileId, app, reset, open, setChecks, checkLimit]);

  const handleCancel = () => {
    setChecks(0);
    reset();
  };

  if (!patient) {
    return null;
  }

  return (
    <>
      {checks === 0 && (
        <CompletedCaseModificationWarning
          patient={patient}
          proceed={() => setChecks(1)}
          cancel={handleCancel}
        />
      )}
      {!!organizationId && checks === 1 && (
        <UnstableUsageDetector
          organizationId={organizationId}
          cancel={handleCancel}
          onDownload={handleCancel}
          proceed={() => setChecks(2)}
        />
      )}
    </>
  );
};

DibsOpener.propTypes = {
  organizationId: PropTypes.number,
  patient: PropTypes.shape({
    id: PropTypes.number.isRequired
  }),
  app: PropTypes.number,
  fileId: PropTypes.number,
  reset: PropTypes.func.isRequired,
  open: PropTypes.func.isRequired
};

DibsOpener.defaultProps = {
  organizationId: null,
  patient: null,
  app: '',
  fileId: null
};

export default connect(
  state => {
    const { patient, app, fileId } = state.dibsOpener;
    return {
      organizationId: state.auth.currentOrganization?.id,
      patient,
      app,
      fileId
    };
  },
  dispatch => {
    return {
      reset: () => dispatch(resetDibsOpener()),
      open: (app, path) => dispatch(openDIBS(app, path))
    };
  }
)(DibsOpener);
